import React from 'react';
import { Page, View, Text, Image, StyleSheet } from '@react-pdf/renderer';
import { registerPdfFonts } from './fonts/registerFonts';
import chatbeatPdfBg from './assets/chatbeat-pdf-bg';
import chatbeatLogoFull from './assets/chatbeat-logo-full';
import { PDF_FONTS } from './pdfTypography';

registerPdfFonts();

const A4_WIDTH = 595.28;
const A4_HEIGHT = 841.89;

/** Natural pixels of embedded PNG from brand asset (logo-sm.svg) */
const LOGO_FULL_NATURAL_W = 671;
const LOGO_FULL_NATURAL_H = 129;
/** Display width (pt); height derived to preserve aspect ratio */
const HEADER_LOGO_WIDTH = 135;
const HEADER_LOGO_HEIGHT = (HEADER_LOGO_WIDTH * LOGO_FULL_NATURAL_H) / LOGO_FULL_NATURAL_W;

const MARGIN_X = 56;
const HEADER_TOP = 32;
/** Space below fixed header before body (logo + breathing room) */
const MARGIN_TOP = Math.ceil(HEADER_TOP + HEADER_LOGO_HEIGHT + 22);
const MARGIN_BOTTOM = 60;

const styles = StyleSheet.create({
  page: {
    width: A4_WIDTH,
    height: A4_HEIGHT,
    fontFamily: 'Inter',
    fontSize: PDF_FONTS.body,
    color: '#000000',
    paddingTop: MARGIN_TOP,
    paddingBottom: MARGIN_BOTTOM,
    paddingLeft: MARGIN_X,
    paddingRight: MARGIN_X,
  },
  backgroundWrapper: {
    position: 'absolute',
    top: 0,
    left: 0,
    width: A4_WIDTH,
    height: A4_HEIGHT,
  },
  backgroundImage: {
    width: '100%',
    height: '100%',
  },
  header: {
    position: 'absolute',
    top: HEADER_TOP,
    left: MARGIN_X,
  },
  headerLogo: {
    width: HEADER_LOGO_WIDTH,
    height: HEADER_LOGO_HEIGHT,
  },
  footer: {
    position: 'absolute',
    bottom: 28,
    right: MARGIN_X,
    fontSize: PDF_FONTS.body,
    color: '#000000',
  },
});

interface ChatbeatPdfTemplateProps {
  children: React.ReactNode;
}

const ChatbeatPdfTemplate: React.FC<ChatbeatPdfTemplateProps> = ({ children }) => (
  <Page size="A4" style={styles.page}>
    <View style={styles.backgroundWrapper} fixed>
      <Image src={chatbeatPdfBg} style={styles.backgroundImage} />
    </View>

    <View style={styles.header} fixed>
      <Image src={chatbeatLogoFull} style={styles.headerLogo} />
    </View>

    {children}

    <Text
      style={styles.footer}
      fixed
      render={({ pageNumber, totalPages }) => `${pageNumber}/${totalPages}`}
    />
  </Page>
);

export { ChatbeatPdfTemplate, A4_WIDTH, A4_HEIGHT, MARGIN_X };
export default ChatbeatPdfTemplate;
